export const RECURRING_TIME_UNITS = {
    WEEK: 'time_unit_week',
    MONTH: 'time_unit_month'
};
